import * as AntdComponents from 'antd'
import React from 'react'
import { SidebarList } from './SidebarList';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { STATIC_IMAGES } from '../utils/StaticImages';
import { ReactIcons } from '../utils/ReactIcons';
import { RouterKeys } from '../Routes/RouterKeys';
import { LogoutAction } from '../redux/slices/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import CustomDivider from '../components/CustomDivider';
import { useDynamicMutationMutation } from '../redux/service/apiSlice';
import { Endpoints } from '../utils/Endpoints';
const { Header, Sider, Content } = AntdComponents.Layout;

const MainLayout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const refreshToken = useSelector((state) => state?.auth?.tokenData?.refreshToken)
  const [logoutMutation] = useDynamicMutationMutation();
  const [activeIndex, setActiveIndex] = React.useState(RouterKeys.NON_Auth.HOME);


  // Setting Active sider
  React.useEffect(() => {
    const pathWithoutQuery = location.pathname.split('?')[0]; // Remove query parameters
    // Define a map of paths to active indexes
    const pathToIndexMap = {
      [`${RouterKeys.NON_Auth.HOME}`]: `${RouterKeys.NON_Auth.HOME}`,
      [`${RouterKeys.NON_Auth.USER_Detail}`]: `${RouterKeys.NON_Auth.USERS}`,
      [`${RouterKeys.NON_Auth.CATEGORY_DETAIL}`]: `${RouterKeys.NON_Auth.CATEGORY}`,
      [`${RouterKeys.NON_Auth.COMMUNITY_DETAIL}`]: `${RouterKeys.NON_Auth.COMMUNITY}`,
      [`${RouterKeys.NON_Auth.REPORT_POST_DETAIL}`]: `${RouterKeys.NON_Auth.REPORT_POST}`,
      [`${RouterKeys.NON_Auth.REPORT_COMMENTS_DETAIL}`]: `${RouterKeys.NON_Auth.REPORT_COMMENTS}`,
    };

    // Check for a direct match in the map
    if (pathToIndexMap[pathWithoutQuery]) {
      setActiveIndex(pathToIndexMap[pathWithoutQuery]);
    } else {
      // Fallback to the pathname if no match is found
      setActiveIndex(pathWithoutQuery);
    }
  }, [location.pathname]);

  const handleMenuClick = (route) => {
    setActiveIndex(route);
  };
  const popOverContent = (
    <>
      <div role='button' tabIndex={0} className="bg-Black rounded-10 py-2"
      >
        <AntdComponents.Typography className="text-para text-White px-3 py-2" onClick={() => navigate(RouterKeys.NON_Auth.CHANGE_PASSWORD)}>Change password</AntdComponents.Typography>
        <CustomDivider className='h-[0.5px] bg-Grey' />
        <AntdComponents.Typography className="text-para text-White px-3 py-2" onClick={() => logoutHandle()}>Logout</AntdComponents.Typography>
      </div>
    </>
  );
  const logoutHandle = async () => {
    try {
      await logoutMutation({
        endpoint: Endpoints.AUTH.LOGOUT,
        method: 'POST',
        body: { refresh_token: refreshToken },
      });
    } catch (err) {
      // Local session must still be cleared even if the backend call fails
    } finally {
      navigate('/')
      dispatch(LogoutAction())
    }
  }
  return (
    <div>
      <AntdComponents.Layout>
        <Header className='h-24'>
          <div className="flex items-center justify-between m-auto" style={{ height: '100%' }}>
            <div className="">
              <AntdComponents.Image preview={false} src={STATIC_IMAGES.LOGO} alt="logo" height={50} width={'auto'} role='button' onClick={() => navigate(RouterKeys.NON_Auth.HOME)} />
            </div>
            <div className="">
              <AntdComponents.Popover content={popOverContent} arrow={false}>
                <div className="flex items-center justify-between px-5 border-2 border-Purple rounded-5 h-12 " style={{ cursor: 'pointer' }}>
                  <AntdComponents.Typography className="text-White font-Poppins font-bold">Admin</AntdComponents.Typography>
                  <ReactIcons.ArrowDownIcon size={25} color="" style={{ marginLeft: 8 }} />
                </div>
              </AntdComponents.Popover>
            </div>
          </div>
        </Header>
        <AntdComponents.Layout className=''>
          <Sider width="10%" style={{ maxHeight: 'calc(100vh - 6rem)' }}
            className='shadow-sideShadow bg-Black overflow-y-auto mt-1 min-w-[60px] md:min-w-[30%] lg:min-w-[26%] xl:min-w-[15%]'
          >
            <AntdComponents.Menu
              mode="inline"
              selectable={true}
              selectedKeys={[activeIndex]}
              defaultSelectedKeys={[RouterKeys.NON_Auth.HOME]}
              theme='dark'
            >
              {
                SidebarList?.map((item, index) => {
                  const isActive = activeIndex === item.routes;
                  return (
                    <React.Fragment key={item?.title}>
                      <div
                        className={`${isActive && 'border border-Pink'}`}>
                        <div className={`${isActive && 'border border-Purple'}`}>
                          {
                            item?.type == 'subMenu' ?
                              <AntdComponents.Menu.SubMenu title={<div className="side_menu_tab md:px-5 flex items-center gap-3 text-White" style={{ color: '#000' }}>
                                <span>
                                  {item.icon}
                                </span>
                                <span className='hidden md:block mb-2'>
                                  {item?.title}
                                </span>
                              </div>}  >
                                {
                                  item?.submenus?.map((data, key) => {
                                    const isActive2 = activeIndex === data.routes;
                                    return (
                                      <React.Fragment key={data?.title}>
                                        <div className=''>
                                          <div className={`${isActive2 && 'border border-Pink'}`} style={{ marginTop: '0.12rem' }}>
                                            <div
                                              className={`${isActive2 && 'border border-Purple'} flex items-center gap-3`}
                                              role='button'
                                              tabIndex={0}
                                              onClick={() => handleMenuClick(data?.routes)}
                                              onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                  handleMenuClick(data?.routes)
                                                }
                                              }}>
                                              <AntdComponents.Menu.Item
                                                onClick={() => { navigate(`${data?.routes}`) }}
                                                className={`side_menu_tab w-full h-10 p-2 md:p-6 ${isActive2 ? 'bg-Black border border-Blue' : 'bg-DarkGrey'}`}
                                              >
                                                <span className='ps-0 md:ps-8 flex items-center gap-3'>
                                                  {data?.icon}
                                                  {data?.title}
                                                </span>
                                              </AntdComponents.Menu.Item>
                                            </div>
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    )
                                  })
                                }
                              </AntdComponents.Menu.SubMenu>
                              :
                              <AntdComponents.Menu.Item
                                onClick={() => { navigate(`${item?.routes}`) }}
                                className={`side_menu_tab w-full h-10 p-2 md:p-6 ${isActive ? 'bg-Black border border-Blue' : 'bg-DarkGrey'}`}
                              >
                                <div className={`flex items-center gap-3 mt-2`}
                                  role='button'
                                  tabIndex={0}
                                  onClick={() => handleMenuClick(item?.routes)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      handleMenuClick(item?.routes)
                                    }
                                  }}
                                >
                                  <span>
                                    {item.icon}
                                  </span>
                                  <span className='hidden md:block mb-2'>
                                    {item?.title}
                                  </span>
                                </div>
                              </AntdComponents.Menu.Item>
                          }
                        </div>
                      </div>
                      {
                        SidebarList.length - 1 != index &&
                        <CustomDivider />
                      }
                    </React.Fragment>
                  )
                })
              }
            </AntdComponents.Menu>
          </Sider>
          <Content style={{ maxHeight: 'calc(100vh - 6rem)' }} className='py-5 px-3 md:px-10 overflow-y-auto'>
            <Outlet />
          </Content>

        </AntdComponents.Layout>
      </AntdComponents.Layout>
    </div>
  )
}

export default MainLayout
